<template>
    <v-card flat fill-height style="height:100%;">
        <v-card-title primary class="title" style="height:10%;">Subsystems state</v-card-title>
        <v-card-actions fill-height style="height:90%;">    
            <v-container fluid fill-height grid-list-md style="padding:10px;">
                <v-layout fill-height column>
                    <v-layout v-if="!!data && data.length" v-for="n in data[0].length" :key="n" row>
                        <v-flex d-flex md6>
                            <v-flex  d-flex md3 style="justify-content:center;align-items:center;">
                                <v-avatar style="height: 25px;width: 25px;" flat>
                                    <img v-if="data[0][n-1].value==20" :src=red>
                                    <img v-else-if="data[0][n-1].value==10" :src=orange>
                                    <img v-else-if="data[0][n-1].value==0" :src=green>
                                    <img v-else :src=gray>
                                </v-avatar>
                            </v-flex>
                            <v-flex md9 d-flex style="align-items:center;font-size:24px;">{{data[0][n-1].system}}</v-flex>
                        </v-flex>
                        <v-flex d-flex md6>
                             <v-flex  d-flex md3 style="justify-content:center;align-items:center;">
                                <v-avatar style="height: 25px;width: 25px;" flat>
                                    <img v-if="data[1][n-1].value==20" :src=red>
                                    <img v-else-if="data[1][n-1].value==10" :src=orange>
                                    <img v-else-if="data[1][n-1].value==0" :src=green>
                                    <img v-else :src=gray>
                                </v-avatar>
                            </v-flex>
                            <v-flex md9 d-flex style="align-items:center;font-size:24px;">{{data[1][n-1].system}}</v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="!!data && data.length>2" row>
                        <v-layout fill-height column>
                            <v-layout v-for="sys in data[2]" :key="sys" row>
                                <v-flex  d-flex md3></v-flex>
                                <v-flex d-flex md6>
                                    <v-flex  d-flex md3 style="justify-content:center;align-items:center;">
                                        <v-avatar style="height: 25px;width: 25px;" flat>
                                            <img v-if="sys.value==20" :src=red>
                                            <img v-else-if="sys.value==10" :src=orange>
                                            <img v-else-if="sys.value==0" :src=green>
                                            <img v-else :src=gray>
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex md9 d-flex style="align-items:center;font-size:24px;">{{sys.system}}</v-flex>
                                </v-flex>
                                <v-flex  d-flex md3></v-flex>
                            </v-layout>
                        </v-layout>
                    </v-layout>
                </v-layout>               
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "SubsystemState",
        components: {
        },
        props: {
            data:Array
        },
        data: function () {
            return { 
                red:require('../assets/RedLight.png'),        
                orange:require('../assets/OrangeLight.png'),
                green:require('../assets/GreenLight.png'),
                gray:require('../assets/check-mark-circle3.png')
            }
        },
        methods: {
        },
        mounted() {
        },
        watch: {
        }
    }
</script>

<style scoped>
</style>
